"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    InlineLocationLink: ()=>InlineLocationLink
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
require("react");
const SinglePinIcon_js_namespaceObject = require("../Maps/SinglePinIcon.js");
const index_js_namespaceObject = require("../../constants/index.js");
const InlineLocationLink = (props)=>{
    const { pinsInCurrentLine, handleMapButtonClick, metadata } = props;
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Button, {
        variation: "link",
        style: {
            transform: 'translateY(5px)'
        },
        onClick: function(event) {
            event.stopPropagation();
            event.preventDefault();
            handleMapButtonClick(pinsInCurrentLine, metadata);
        },
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
            alignItems: "center",
            children: [
                (0, SinglePinIcon_js_namespaceObject.MapIcon)({
                    type: metadata?.type,
                    iconProp: {
                        color: 'primary',
                        size: 20
                    }
                }),
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text.span, {
                    fontSize: 2,
                    ml: 1,
                    bold: metadata.type === index_js_namespaceObject.mapPinType.HOTEL,
                    children: metadata.name
                })
            ]
        })
    });
};
exports.InlineLocationLink = __webpack_exports__.InlineLocationLink;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "InlineLocationLink"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
